import {useMePermissions} from "@/src/modules/core/store/me";

export default function useHasPermission(permission) {
  const permissions = useMePermissions();

  const hasPermission = permissions.has(permission);

  return hasPermission;
}
